/**
 * `clients.shop_plan` mirrors Shopify `plan.displayName` at install (and may be updated via webhooks elsewhere).
 * Checkout UI extensions with buyer-journey / block progress require a Plus-capable shop.
 */

/**
 * @param {string|null|undefined} shopPlanRaw
 * @returns {boolean}
 */
export function isShopifyPlusPlan(shopPlanRaw) {
  const s = String(shopPlanRaw ?? "").trim().toLowerCase();
  if (!s) return false;
  return s.includes("plus");
}

/**
 * @param {string|null|undefined} shopPlanRaw
 * @returns {string}
 */
export function formatShopPlanLabel(shopPlanRaw) {
  const s = String(shopPlanRaw ?? "").trim();
  return s || "Unknown (not synced)";
}

/** Aligns with Crowdfunding/Node `DEVELOPMENT_BILLING_PLAN_KEYS` + common displayName substrings. */
const DEV_PLAN_EXACT = new Set([
  "development",
  "staff",
  "developer preview",
  "trial",
  "shopify plus partner sandbox",
  "affiliate",
  "partner_test",
  "plus_partner_sandbox",
]);

/**
 * Development / staff / Plus sandbox–style plans: no Plus-only checkout warning.
 * @param {string|null|undefined} shopPlanRaw
 */
export function isDevelopmentShopPlan(shopPlanRaw) {
  const s = String(shopPlanRaw ?? "").trim().toLowerCase();
  if (!s) return false;
  if (DEV_PLAN_EXACT.has(s)) return true;
  if (s.includes("development")) return true;
  if (s.includes("partner sandbox")) return true;
  if (s.includes("dev preview")) return true;
  if (s.includes("pause and build") || s === "pause") return true;
  return false;
}
